import { Tooltip } from '@cambridgeassessment/cambridge-ui';
import React from 'react';

interface Props {
  tooltip?: string;
  children: React.ReactElement;
}

export const ToggleRowTooltip: React.FC<Props> = ({ tooltip, children }) => {
  if (!tooltip) {
    return children;
  }

  return (
    <Tooltip arrow={true} dataQaId='${qaId}-switch-tooltip' title={tooltip} placement='top-start' enterDelay={500}>
      <div>{children}</div>
    </Tooltip>
  );
};
